import React, { useEffect, useState, useRef } from "react";
import "./Payment.css";
import { useAuth } from "../../../../context/LoginContext/AuthContext";
import toast from "react-hot-toast";
import { loadRazorpay } from "./LoadRazorpay";
import { PaymentDetailsLeft } from "./PaymentDetailsLeft";
import { PaymentDetailsRight } from "./PaymentDetailsRight";
export const ParentPayment = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  // ✅ ENV DEBUG (safe)
  const { user, fetchWithAuth } = useAuth();
  const [plans, setPlans] = useState([]);
  const [lastFetchedPlans, setLastFetchedPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const number_of_kids = localStorage.getItem("number_of_kids");
  const [coupon, setCoupon] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [couponSuccess, setCouponSuccess] = useState("");
  const [estimatedData, setEstimatedData] = useState(null);
  const [processingGateway, setProcessingGateway] = useState(null);
  const hasFiredAddToCart = useRef(false);
  const student_ids = (localStorage.getItem("student_ids") || "")
    .split(",")
    .map((id) => Number(id.trim()))
    .filter((id) => !isNaN(id));
  const handleApply = async () => {
    const trimmed = coupon.trim();
    if (trimmed === "") return;

    setLoading(true);
    setError("");
    if (!user || !user.token) {
      return;
    }
    try {
      const response = await fetchWithAuth(
        `${apiUrl}/subscriptions/billing/estimate`,
        {
          method: "POST",
          body: JSON.stringify({
            coupon_code: trimmed,
            quantity: number_of_kids,
            plan_id: plans?.plans?.[0]?.id,
            mode: "create",
            student_ids,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setAppliedCoupon(trimmed);
        setCouponSuccess("Coupon Applied Successfully");
        setEstimatedData(data);
        setIsCouponApplied(true);
      } else {
        setError(data?.message || "Invalid coupon code");
      }
    } catch (err) {
      setError("Error validating coupon");
    } finally {
      setLoading(false);
    }
  };
  const handleRemove = () => {
    setAppliedCoupon(null);
    setCoupon("");
    setError("");
    setIsCouponApplied(false);
    setCouponSuccess("");
    RemoveCoupon();
  };
  const RemoveCoupon = async () => {
    try {
      const estimateResponse = await fetchWithAuth(
        `${apiUrl}/subscriptions/billing/estimate`,
        {
          method: "POST",
          body: JSON.stringify({
            coupon_code: "",
            quantity: number_of_kids,
            plan_id: plans?.plans?.[0]?.id,
            mode: "create",
            student_ids,
          }),
        }
      );

      const estimateData = await estimateResponse.json();

      if (estimateResponse.ok) {
        setEstimatedData(estimateData);
        setLoadingPlans(false);
      }
    } catch (err) {}
  };
  useEffect(() => {
    const fetchPlans = async () => {
      if (!user || !user.token) {
        return;
      }

      try {
        const response = await fetchWithAuth(
          `${apiUrl}/plans?mode=create&quantity=${number_of_kids}&auth_token=${user.token}`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch plans: ${response.statusText}`);
        }

        const data = await response.json();

        if (JSON.stringify(data) !== JSON.stringify(lastFetchedPlans)) {
          setPlans(data);
          setLastFetchedPlans(data);
          setLoadingPlans(false);
          localStorage.setItem("trial_days", data?.plans?.[0]?.trial_days);
          setLoadingPlans(true);
          setError("");

          try {
            const estimateResponse = await fetchWithAuth(
              `${apiUrl}/subscriptions/billing/estimate`,
              {
                method: "POST",
                body: JSON.stringify({
                  coupon_code: "",
                  quantity: number_of_kids,
                  plan_id: data?.plans?.[0]?.id,
                  mode: "create",
                  student_ids,
                }),
              }
            );

            const estimateData = await estimateResponse.json();

            if (estimateResponse.ok) {
              setEstimatedData(estimateData);
              setLoadingPlans(false);
            }
          } catch (err) {
            // console.error("Coupon validation error:", err);
            // setError("Error validating coupon");
          }
        }
      } catch (error) {
        toast.error("Error fetching plans:", error.message);
      }
    };

    fetchPlans();
  }, [
    lastFetchedPlans,
    apiUrl,
    user,
    number_of_kids,
    student_ids,
    fetchWithAuth,
  ]);

  // Fire add_to_cart event when plans successfully load
  useEffect(() => {
    if (
      !hasFiredAddToCart.current &&
      plans?.plans?.length > 0 &&
      !loadingPlans
    ) {
      const items = plans.plans.map((plan) => ({
        item_id: String(plan.id),
        item_name: plan.name,
        item_category: "YQ Yearly Subscription Plan",
        price: Number(plan.final_price) || 0,
        currency: String(plan.currency || "INR"),
        trial_days: plan.trial_days,
        billing_cycle: plan.billing_cycle,
        tiers: plan.tiers,
        discount_percent: plan.discount_percent,
        description: plan.description,
      }));

      // Push to GTM dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        currency: items[0].currency,
        value: items.reduce((sum, i) => sum + i.price, 0), // sum of all plan prices
        items,
      });

      // Direct GA4 send (for DebugView)
      if (typeof window.gtag === "function") {
        window.gtag("event", "add_to_cart", {
          currency: items[0].currency,
          value: items.reduce((sum, i) => sum + i.price, 0),
          items,
          debug_mode: true, // 👈 ensures you see it in DebugView
        });
        console.log("✅ Sent add_to_cart event to GA4:", {
          currency: items[0].currency,
          value: items.reduce((sum, i) => sum + i.price, 0),
          items,
        });
      }

      hasFiredAddToCart.current = true; // ✅ Mark as fired
    }
  }, [plans, loadingPlans]);

  // GA4 begin_checkout event
  const fireBeginCheckout = (plans, coupon, number_of_kids) => {
    if (!plans?.plans?.length) return;

    const items = plans.plans.map((plan) => ({
      item_id: String(plan.id),
      item_name: plan.name,
      item_category: "YQ Yearly Subscription Plan",
      price: Number(plan.final_price) || 0,
      currency: String(plan.currency || "INR"),
      quantity: Number(number_of_kids) || 1,
      coupon: coupon || undefined,
    }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "begin_checkout",
      currency: items[0].currency,
      value: items.reduce((sum, i) => sum + i.price, 0),
      coupon: coupon || undefined,
      items,
    });

    if (typeof window.gtag === "function") {
      window.gtag("event", "begin_checkout", {
        currency: items[0].currency,
        value: items.reduce((sum, i) => sum + i.price, 0),
        coupon: coupon || undefined,
        items,
        debug_mode: true, // so you can see it in DebugView
      });
      console.log("✅ Sent begin_checkout event to GA4:", {
        currency: items[0].currency,
        value: items.reduce((sum, i) => sum + i.price, 0),
        coupon,
        items,
      });
    }
  };

  // GA4 purchase event
  const firePurchase = (
    plans,
    coupon,
    number_of_kids,
    transactionId,
    paymentMethod
  ) => {
    if (!plans?.plans?.length) return;

    const items = plans.plans.map((plan) => ({
      item_id: String(plan.id),
      item_name: plan.name,
      item_category: "YQ Yearly Subscription Plan",
      price: Number(plan.final_price) || 0,
      currency: String(plan.currency || "INR"),
      quantity: Number(number_of_kids) || 1,
      coupon: coupon || undefined,
    }));

    const value = items.reduce((sum, i) => sum + i.price, 0);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "purchase",
      transaction_id: transactionId || String(Date.now()), // unique order/payment ID
      affiliation: paymentMethod || "Online",
      currency: items[0].currency,
      value,
      coupon: coupon || undefined,
      items,
    });

    if (typeof window.gtag === "function") {
      window.gtag("event", "purchase", {
        transaction_id: transactionId || String(Date.now()),
        affiliation: paymentMethod || "Online",
        currency: items[0].currency,
        value,
        coupon: coupon || undefined,
        items,
        debug_mode: true, // for DebugView
      });
      console.log("✅ Sent purchase event to GA4:", {
        transaction_id: transactionId,
        affiliation: paymentMethod,
        currency: items[0].currency,
        value,
        coupon,
        items,
      });
    }
  };

  const subscribeToPlanStripe = async () => {
    if (processingGateway) return;
    setProcessingGateway("stripe");
    fireBeginCheckout(plans, coupon, number_of_kids); // 👈 fire event first
    const subscriptions = localStorage
      .getItem("student_ids")
      .split(",")
      .map((id) => id.trim())
      .map((id) => ({ student_id: id }));

    const bodyData = {
      plan_id: String(plans?.plans?.[0]?.id),
      subscriptions,
      mode: "create",
      payment_method: "stripe",
      num_kids: number_of_kids,
    };
    if (coupon.trim()) {
      bodyData.coupon_code = coupon.trim();
    }
    try {
      const response = await fetchWithAuth(
        `${apiUrl}/stripe/create-subscription`,
        {
          method: "POST",
          body: JSON.stringify(bodyData),
        }
      );

      localStorage.setItem("payment_mode", "stripe");
      localStorage.setItem("mode", "create");

      const result = await response.json();

      if (!response.ok) {
        toast.error(result.message || result.error);
        setProcessingGateway(null);
        return;
      }

      if (response.ok) {
        localStorage.setItem("mode", "create");
        // Fire purchase event
        firePurchase(
          plans,
          coupon,
          number_of_kids,
          result.subscription_id,
          "Stripe"
        );
        window.location.href = result.approval_link;
      }
    } catch (error) {
      setProcessingGateway(null);
      toast.error("Error subscribing:", error);
    }
  };
  const subscribeToPlanPaypal = async () => {
    if (processingGateway) return;
    setProcessingGateway("paypal");
    fireBeginCheckout(plans, coupon, number_of_kids); // 👈 fire event first
    const subscriptions = localStorage
      .getItem("student_ids")
      .split(",")
      .map((id) => id.trim())
      .map((id) => ({ student_id: id }));

    const bodyData = {
      plan_id: String(plans?.plans?.[0]?.id),
      subscriptions,
      mode: "create",
      payment_method: "paypal",
      num_kids: number_of_kids,
    };
    if (coupon.trim()) {
      bodyData.coupon_code = coupon.trim();
    }

    try {
      const response = await fetchWithAuth(
        `${apiUrl}/paypal/create-subscription`,
        {
          method: "POST",
          body: JSON.stringify(bodyData),
        }
      );

      const result = await response.json();
      localStorage.setItem("payment_mode", "paypal");
      localStorage.setItem("mode", "create");

      if (!response.ok) {
        toast.error(result.message || result.error);
        setProcessingGateway(null);
        return;
      }

      if (response.ok) {
        localStorage.setItem("mode", "create");
        // Fire purchase event
        firePurchase(
          plans,
          coupon,
          number_of_kids,
          result.subscription_id,
          "PayPal"
        );
        window.location.href = result.approval_link;
      }
    } catch (error) {
      setProcessingGateway(null);
      toast.error("Error subscribing:", error);
    }
  };
  const subscribeToPlanRazorPay = async () => {
    if (processingGateway) return;
    setProcessingGateway("razorpay");
    fireBeginCheckout(plans, coupon, number_of_kids); // 👈 fire event first
    const isLoaded = await loadRazorpay();
    if (!isLoaded) {
      toast.error("Razorpay SDK failed to load. Check your connection.");
      setProcessingGateway(null);
      return;
    }

    const subscriptions = localStorage
      .getItem("student_ids")
      .split(",")
      .map((id) => id.trim())
      .map((id) => ({ student_id: id }));

    const bodyData = {
      plan_id: String(plans?.plans?.[0]?.id),
      subscriptions,
      mode: "create",
      payment_method: "razorpay",
      num_kids: number_of_kids,
    };

    if (coupon.trim()) {
      bodyData.coupon_code = coupon.trim();
    }

    try {
      const response = await fetchWithAuth(
        `${apiUrl}/razorpay/create-subscription`,
        {
          method: "POST",
          body: JSON.stringify(bodyData),
        }
      );

      const result = await response.json();
      localStorage.setItem("payment_mode", "razorpay");
      localStorage.setItem("mode", "create");

      if (!response.ok) {
        toast.error(result.message || result.error);
        setProcessingGateway(null);
        return;
      }

      if (!result.subscription_id) {
        toast.error("Failed to create subscription");
        setProcessingGateway(null);
        return;
      }

      localStorage.setItem("mode", "create");

      // ✅ Now window.Razorpay is safe to use
      const options = {
        key: process.env.REACT_APP_PUBLIC_RAZORPAY_TEST_KEY_ID,
        subscription_id: result.subscription_id,
        name: "Yuva Quest",
        description: "Subscription Payment",
        image:
          "https://d2lvj32mp5x83n.cloudfront.net/static/logo-YQ/YQLogoPlain.png",
        theme: { color: "#2d8cf0" },
        handler: async function (resp) {
          // console.log("Payment Success:", resp);
          setTimeout(async () => {
            await fetchWithAuth(`${apiUrl}/razorpay/payment-callback`, {
              method: "POST",
              body: JSON.stringify({
                subscription_id: result?.subscription_id,
              }),
            });

            // Fire purchase event
            firePurchase(
              plans,
              coupon,
              number_of_kids,
              result?.subscription_id,
              "Razorpay"
            );

            toast.success(
              "Subscription registered, waiting for Razorpay to finalize billing details."
            );
            window.location.href = `/razorpay/result/?subscription_id=${result.subscription_id}&status=success`;
          }, 1000);
        },
        modal: {
          ondismiss: function () {
            // console.log("Checkout closed");
            // toast.error("⚠️ Payment Cancelled ");
            setProcessingGateway(null);
            window.location.href = `/razorpay/result/?subscription_id=${result.subscription_id}&status=cancel`;
          },
        },
        prefill: {
          name: user?.name || "Guest User",
          email: user?.email || "test@example.com",
          contact: user?.phone || "9999999999",
        },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (resp) {
        // console.error("Payment Failed:", resp.error);
        // toast.error("❌ Payment Failed");
        setProcessingGateway(null);
        window.location.href = `/razorpay/result/?subscription_id=${result.subscription_id}&status=failed`;
      });

      rzp.open();
    } catch (error) {
      // console.error("Error subscribing:", error);
      setProcessingGateway(null);
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <div className="container responsive-margin">
        <div
          className="row  align-items-center justify-content-center"
          style={{ gap: "30px" }}
        >
          {/* Left Side */}
          <PaymentDetailsLeft
            loadingPlans={loadingPlans}
            estimatedData={estimatedData}
            plans={plans}
            user={user}
            number_of_kids={number_of_kids}
          />

          {/* Right Side */}
          {/* export const PaymentDetailsRight = ({loadingPlans,isCouponApplied,plans,estimatedData,appliedCoupon,coupon,couponSuccess,handleApply,handleRemove,setCoupon,loading,subscribeToPlanPaypal,subscribeToPlanRazorPay,subscribeToPlanStripe,error})=>{ */}
          <PaymentDetailsRight
            loadingPlans={loadingPlans}
            isCouponApplied={isCouponApplied}
            plans={plans}
            estimatedData={estimatedData}
            appliedCoupon={appliedCoupon}
            coupon={coupon}
            couponSuccess={couponSuccess}
            handleApply={handleApply}
            handleRemove={handleRemove}
            setCoupon={setCoupon}
            loading={loading}
            processingGateway={processingGateway}
            subscribeToPlanPaypal={subscribeToPlanPaypal}
            subscribeToPlanRazorPay={subscribeToPlanRazorPay}
            subscribeToPlanStripe={subscribeToPlanStripe}
            error={error}
          />
        </div>
      </div>
    </>
  );
};
